function resizeContentUntilFits(child, parent) {
    let tries = 0;
    let baseFontSize = 0;
    let unit;
    let fontSize = 0;
    while (child.width() > parent.width()) {
        if (baseFontSize === 0) {
            const fontSize = child.css('font-size');
            baseFontSize = parseInt(fontSize);
            unit = fontSize.split(baseFontSize.toString())[1];
        }
        fontSize = (baseFontSize - 0.01 * tries);
        child.css({fontSize: fontSize + '' + unit});

        tries++;
    }

    jQuery(window).unbind('resize.resizedContent').bind('resize.resizedContent', function() {
        // jQuery('.icon-resize-style').remove();
        child.css({fontSize: baseFontSize + '' + unit});
        resizeContentUntilFits(child, parent);
    });
}